import React, {useEffect, useState} from "react"

import "./Test.css"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import PersonalTab from "../../component/Test/PersonalTab"
import PersonalCreate from "../../component/Test/PersonalCreate"
import {retrieveData, sendRequest} from "../../common";
import {useNavigate} from "react-router-dom";

function PersonalCode({}) {

	const navigate = useNavigate()

	const [user, setUser] = useState()

	const [products, setProducts] = useState([])
	const [product, setProduct] = useState()

	const getProducts = () => {
		sendRequest('product/product/?group=개인', 'GET', null, data => {
			setProducts(data)
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
		getProducts()
	}, [])

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"개인검사 인증코드"} />
					<div className="testWrap">
						<PersonalTab isFirst={true}/>
						{!product?.id ?
							<section className="personalCode">
								<form name="personalCode">
									<div className="testTableWrap">
										<table className="testTable">
											<colgroup>
												<col width="80%"/>
											</colgroup>
											<thead>
											<tr>
												<th>검사종류</th>
												<th>잔여캐시</th>
												<th>인증코드</th>
											</tr>
											</thead>
											<tbody>
											{products?.map((item, index) => {
												return (
													<tr>
														<td className="alignLt">[{item?.group}] {item?.name}</td>
														<td className="cash blue">{item?.remainCash}</td>
														<td>
															{item?.remainCash > 0 ?
																<button type="button" className="createBtn"
																				onClick={() => setProduct(item)}>생성하기</button>
																:
																<button type="button" className="buyBtn" onClick={(e) => {
																	e.preventDefault()
																	navigate('/purchase-online')
																}}>구매하기</button>
															}
														</td>
													</tr>
												)
											})}
											{!products?.length &&
												<div style={{marginTop: 50, fontSize: 20}}>자격 및 수료여부를 등록해주세요.</div>
											}
											</tbody>
										</table>
									</div>
								</form>
							</section>
							:
							<PersonalCreate product={product}/>
						}
					</div>
				</div>
			</div>
			<RightFooter />
		</>
	)
}

export default PersonalCode
